/* © CNES */
import { Toast } from 'primereact/toast';
import { Toolbar } from 'primereact/toolbar';
import React, { useCallback, useContext, useRef } from 'react';
import { ConfigContext } from '../../context/ConfigContext';
import './AppHeader.scss';
import { DataBadge } from './dataBadge/DataBadge';
import { ImageContainer } from './imageContainer/ImageContainer';
import { LoginContainer } from './loginContainer/LoginContainer';
import { NavigationContainer } from './navigationContainer/NavigationContainer';
import { SearchContainer } from './searchContainer/SearchContainer';

type ToastSeverity = 'success' | 'info' | 'warn' | 'error' | undefined;

/**
 * AppHeader to display application header as Toolbar.
 * @param tabindex defines which page from router is currently active.
 * @returns AppHeader Element
 */
export function AppHeader({ tabindex }: { tabindex: number }) {
  const context = useContext(ConfigContext);
  const toast = useRef<Toast>(null);

  /**
   * function called to display toast component
   */
  const displayToast = useCallback(
    (severity: ToastSeverity, summary: string, detail: string) => {
      toast.current?.show({
        severity: severity,
        summary: summary,
        detail: detail,
        life: 3000,
      });
    },
    []
  );

  const startContent = (
    <React.Fragment>
      <ImageContainer />
    </React.Fragment>
  );

  const endContent = (
    <React.Fragment>
      <div className="tabContainer">
        <NavigationContainer tabindex={tabindex} />
        {context.productsAdded?.products?.length !== 0 && <DataBadge />}
      </div>
      {/* HIDDEN <NotificationContainer /> */}
      <LoginContainer />
    </React.Fragment>
  );

  const centerContent = (
    <React.Fragment>
      <SearchContainer displayToast={displayToast} />
    </React.Fragment>
  );

  return (
    <div className="toolbarContainer">
      <Toolbar start={startContent} center={centerContent} end={endContent} />
      <Toast ref={toast} position="top-center" style={{ margin: '2.5em' }} />
    </div>
  );
}
